import { RadioButton } from '@cb/apricot-react';
import { styled } from '@mui/system';

export default styled(RadioButton)`
  & input {
    margin-right: 8px;
  }
`;
